export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-foreground-900 rounded-[32px] overflow-hidden flex flex-col lg:flex-row items-center">
          <div className="w-full lg:w-[42%] p-8 md:p-14 flex flex-col justify-center">
            <span className="inline-block text-xs font-label tracking-wider text-accent-400 bg-accent-900/30 px-4 py-1.5 rounded-full mb-5 whitespace-nowrap">
              随时随地吃瓜
            </span>
            <h2 className="font-heading text-[32px] md:text-[42px] text-background-50 leading-tight mb-4">
              下载51吃瓜网APP
            </h2>
            <p className="text-sm text-foreground-300 leading-relaxed mb-8 max-w-md">
              全网最快最全的吃瓜平台现已推出移动客户端。随时随地接收最新爆料推送，不错过任何一个热门大瓜。支持iOS和Android双平台。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button className="flex items-center justify-center gap-2 px-7 py-3 bg-background-50 text-foreground-900 font-medium text-sm rounded-full hover:bg-accent-200 transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i>
                App Store
              </button>
              <button className="flex items-center justify-center gap-2 px-7 py-3 border-2 border-foreground-300 text-background-50 font-medium text-sm rounded-full hover:bg-foreground-600 transition-all whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </button>
            </div>
          </div>
          <div className="w-full lg:w-[58%] flex items-end justify-center lg:justify-end mt-6 lg:mt-0">
            <div className="w-[260px] md:w-[320px] h-[400px] md:h-[480px] rounded-t-[28px] overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20mockup%20displaying%20a%20modern%20Chinese%20entertainment%20news%20app%20interface%20with%20trending%20gossip%20feed%2C%20warm%20coral%20and%20gold%20accent%20colors%2C%20clean%20card-based%20layout%20with%20headlines%20and%20images%2C%20minimal%20design%2C%20isolated%20on%20transparent%20background%2C%20app%20store%20style%20screenshot&width=640&height=960&seq=app-mockup-phone&orientation=portrait"
                alt="51吃瓜网 APP界面预览"
                title="51吃瓜网移动客户端"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}